// Placeholders rendered inside ReducedPageHeader. The header is SSR-cached, so its cache key
// must reflect which of them are present (see DefaultTemplate cacheKeys.header).
export const HEADER_PLACEHOLDER_KEYS = [
  'headerAccountButton',
  'headerWishlistButton',
  'headerCartButton',
  'menu',
];

// Checkout routes set header_cart_button to `call: null` on purpose, so a missing cart
// placeholder is expected there and must not trigger the fallback or the missing-cart log.
export const CHECKOUT_PATH_MARKER = '/shop/checkout';

export const isCheckoutUrl = (url = '') =>
  typeof url === 'string' && url.includes(CHECKOUT_PATH_MARKER);
